<background-modal>
  <h1 i18n>All Open Camps</h1>
  <div *ngFor="let camp of campList; index as i" class="card-container">
    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title>
          {{camp.name}}
        </mat-card-title>
        <mat-card-subtitle>
          <p>{{camp.startDate | date:'dd.MM.YYYY'}} - {{camp.endDate | date:'dd.MM.YYYY'}}</p>
          <p>{{camp.usualAmount}} €</p>
          <p i18n>from {{camp.minAge}} years</p>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-actions>
        <a mat-raised-button color="primary" i18n [routerLink]="camp.campId">register now</a>
      </mat-card-actions>
    </mat-card>
  </div>
  <div *ngIf="campList.length == 0">
    <span i18n>there are currently no Camps available</span>
    <br>
    <span i18n>go back to the <a i18n-href href="https://yourhomepage.com">Homepage</a></span>
  </div>
</background-modal>